export const SHOW_DIAGNOSIS_PANEL_COOKIE = 'diagnosis-panel'
export const SHOW_PSYCHIATRY_BANNER_COOKIE = 'psychiatry-banner'
export const VARIANT_IN_PARAMS_SLUG = 'variant'
